import React from "react";
import ModalWrapper from './ModalWrapper';

const ImpactoAmbiental = props => {
  return(
    <ModalWrapper
      {...props}
    >
      <div>
        <h4>Impacto Ambiental</h4>
        <p>Conheça algumas de nossas iniciativas para minimizar os impactos do nosso dia a dia, seja de nossa operação ou de nossos(as) clientes:</p>
        <ul className="list-unstyled">
          <li>
            <a target="_blank" href="https://content.paodeacucar.com/sustentabilidade/produtos-a-granel-no-pao?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Reutilizar #paraserfeliz (produtos a granel)
            </a>
          </li>
          <li>
            <a target="_blank" href="https://content.paodeacucar.com/sustentabilidade/residuo-novas-embalagens?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Novo de Novo
            </a>
          </li>
          <li>
            <a target="_blank" href="https://content.paodeacucar.com/sustentabilidade/estacoes-de-reciclagem-pao-de-acucar?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Estações de Reciclagem Pão de Açúcar Unilever
            </a>
          </li>
          <li>
            <a target="_blank" href="https://content.paodeacucar.com/sustentabilidade/descartando-as-capsulas-corretamente?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Descarte de cápsulas de café
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.gpabr.com/pt/sustentabilidade/consumo-e-oferta-consciente?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Descarte de outros materiais (pilhas e baterias, medicamentos)
            </a>
          </li>
          <li>
            <a target="_blank" href="https://content.paodeacucar.com/sustentabilidade/evitar-desperdicio-de-alimentos?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Parceria contra o desperdicio
            </a>
          </li>
        </ul>
      </div>
    </ModalWrapper>
  );
};

export default ImpactoAmbiental;



// WEBPACK FOOTER //
// ./src/components/ImpactoAmbiental.js